import { render, staticRenderFns } from "./TokenBatchAdd.vue?vue&type=template&id=2f90cc53"
import script from "./TokenBatchAdd.vue?vue&type=script&lang=js"
export * from "./TokenBatchAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports